import React from 'react';
import { Button, Col, Row, Spinner } from 'react-bootstrap';

type Branding = {
  cancelAllSubscriptionsButtonText: string;
  updatePreferencesButtonText: string;
  helperText: string;
  propertyPrivacyPolicyEnabled: boolean;
  propertyPrivacyPolicyLink: string;
  propertyPrivacyPolicyText: string;
};

type UpdatePreferencesProps = {
  branding: Branding;
  handleCancel: () => void;
  handleUpdate: () => void;
  isBusy: boolean;
  isCancelDisabled: boolean;
  isUpdateDisabled: boolean;
};

const UpdatePreferences: React.FC<UpdatePreferencesProps> = ({
  branding,
  handleCancel,
  handleUpdate,
  isBusy,
  isCancelDisabled,
  isUpdateDisabled,
}) => (
  <Row className="subscribe__footer m-0 manage__preferences__footer">
    <Col sm={12} md={6}>
      <Button
        className="subscribe__footer__button ebx-btn-lg"
        type="button"
        disabled={isUpdateDisabled}
        onClick={handleUpdate}
      >
        {!isBusy ? (
          branding.updatePreferencesButtonText
        ) : (
          <div>
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
              className="mr-2"
            />
          </div>
        )}
      </Button>
      <Button
        className="p-0 m-0 cancel-all-subscriptions primary-font"
        variant="link"
        disabled={isCancelDisabled}
        onClick={handleCancel}
      >
        {branding.cancelAllSubscriptionsButtonText}
      </Button>
    </Col>
    <Col sm={12} md={6} className="preferences-privacy-policy">
      {branding.helperText}
      {branding.propertyPrivacyPolicyEnabled && (
        <>
          <span> - </span>
          <a href={`${branding.propertyPrivacyPolicyLink}`}>
            {branding.propertyPrivacyPolicyText || 'Privacy Policy'}
          </a>
        </>
      )}
    </Col>
  </Row>
);

export default UpdatePreferences;
